import React from "react";

const getFocusedSessionName = ({
  sessionId,
  paidSession,
  focusedSessions,
  zeroPayments,
}) => {
  if (paidSession?.name && typeof paidSession.name === "string") {
    return paidSession.name;
  }

  const sessionObj = focusedSessions.find((session) => session.id === sessionId);
  if (sessionObj?.value && typeof sessionObj.value === "string") {
    return sessionObj.value;
  }

  const zeroPayment = zeroPayments?.find((item) => item.feeTypeId === sessionId);
  if (zeroPayment?.name && typeof zeroPayment.name === "string") {
    return zeroPayment.name;
  }

  return `Session ${sessionId}`;
};

export const PaidFocusedSessionsSummarySection = ({
  formData,
  selectedFocusedSessions,
  accompanyingPersonFee,
  focusedSessions,
  focusedSessionFees,
  registrationFee,
}) => {
  const accompanyingFeeId = accompanyingPersonFee?.id;
  const paidFocusedSessions = formData.additionalFees
    ? accompanyingFeeId
      ? formData.additionalFees.filter((fee) => fee.feeTypeId !== accompanyingFeeId)
      : formData.additionalFees
    : [];

  console.log("Display logic - Focused Sessions (Paid Only):");
  console.log("  - accompanyingFeeId:", accompanyingFeeId);
  console.log("  - Paid sessions from additionalFees:", paidFocusedSessions);
  console.log("  - Currently selected (state):", selectedFocusedSessions);

  const paidSessionIds = paidFocusedSessions.map((fee) => fee.feeTypeId);
  const newlySelectedSessionIds = selectedFocusedSessions.filter((sessionId) => {
    const notInPaid = !paidSessionIds.includes(sessionId);
    const notInFree = !formData.zeroPayments?.some(
      (zeroPayment) => zeroPayment.feeTypeId === sessionId
    );
    const notAccompanying = !accompanyingFeeId || sessionId !== accompanyingFeeId;
    return notInPaid && notInFree && notAccompanying;
  });

  const allPaidSessionIds = [...paidSessionIds, ...newlySelectedSessionIds];

  console.log("  - Paid session IDs:", paidSessionIds);
  console.log("  - Newly selected (not saved, not free):", newlySelectedSessionIds);
  console.log("  - Final list (paid only):", allPaidSessionIds);

  if (allPaidSessionIds.length === 0) {
    return null;
  }

  const focusedTotal = allPaidSessionIds.reduce((sum, sessionId) => {
    const paidSession = paidFocusedSessions.find(
      (session) => session.feeTypeId === sessionId
    );
    const dbRate = parseFloat(paidSession?.rate || 0);
    const fetchedRate = parseFloat(focusedSessionFees[sessionId]?.rate || 0);
    return sum + (dbRate > 0 ? dbRate : fetchedRate);
  }, 0);
  const currency = registrationFee ? registrationFee.currency : "INR";
  const symbol = formData.country === "India" ? "₹" : "₹";

  return (
    <div className="summary-section">
      <h4>Workshops</h4>
      {allPaidSessionIds.map((sessionId) => {
        const paidSession = paidFocusedSessions.find(
          (session) => session.feeTypeId === sessionId
        );
        const sessionName = getFocusedSessionName({
          sessionId,
          paidSession,
          focusedSessions,
          zeroPayments: formData.zeroPayments,
        });
        const sessionFee = focusedSessionFees[sessionId];
        const isPaid = paidSession && !!paidSession.paymentId;
        const isSaved = paidSession && !paidSession.paymentId;

        let displayRate;
        let displayCurrency;
        if ((isPaid || isSaved) && paidSession) {
          const dbRate = parseFloat(paidSession.rate || 0);
          const fetchedRate = parseFloat(sessionFee?.rate || 0);
          displayRate = dbRate > 0 ? dbRate : fetchedRate;
          displayCurrency =
            paidSession.currency ||
            sessionFee?.currency ||
            registrationFee?.currency ||
            "INR";
        } else if (sessionFee) {
          displayRate = sessionFee.rate;
          displayCurrency = sessionFee.currency || "INR";
        } else {
          displayRate = 0;
          displayCurrency = registrationFee?.currency || "INR";
        }

        const nameContainsAmount = /\([A-Z]{3}\s+[\d,]+\)/i.test(sessionName);

        return (
          <div className="summary-row" key={sessionId}>
            <span className="summary-label" style={{ width: "100%" }}>
              {nameContainsAmount
                ? sessionName
                : `${sessionName} (${displayCurrency} ${parseFloat(
                    displayRate || 0
                  ).toFixed(2)})`}
              {isPaid && (
                <span
                  style={{
                    marginLeft: "8px",
                    color: "#28a745",
                    fontSize: "12px",
                  }}
                >
                  ✓ Paid
                </span>
              )}
              {isSaved && !isPaid && (
                <span
                  style={{
                    marginLeft: "8px",
                    color: "#0d6efd",
                    fontSize: "12px",
                  }}
                >
                  ✓ Saved
                </span>
              )}
            </span>
          </div>
        );
      })}
      <div className="summary-row">
        <span className="summary-label">
          Subtotal ({allPaidSessionIds.length} session
          {allPaidSessionIds.length > 1 ? "s" : ""}):
        </span>
        <span className="summary-value" style={{ fontWeight: "bold" }}>
          {symbol}
          {focusedTotal.toFixed(2)} ({currency})
        </span>
      </div>
    </div>
  );
};
